import { analysisReference } from './analysisReference';
import { scenario } from './scenario';

export const scenarioReference = {
    id: 'scenario_reference_id',
    name: scenario.name,
    score: analysisReference.score,
    precision: 1.2,
};
